export const portfolioOverviewFields = [
  { name: 'title', label: 'Title', required: true },
  { name: 'slug', label: 'Detail Page Slug', required: true, hint: 'Use URL-friendly slug and match the Portfolio Detail page (example: vera-hair-care).' },
  { name: 'category', label: 'Category Badge', required: true },
  { name: 'shortDescription', label: 'Card Description', type: 'textarea', required: true },
  { name: 'mainImageUrl', label: 'Card Image', type: 'image' },
  { name: 'year', label: 'Year', type: 'number' },
  { name: 'industry', label: 'Industry' },
  { name: 'projectDirection', label: 'Project Direction' },
  { name: 'projectId', label: 'Linked Detail Project ID', type: 'number', hint: 'Optional. Links this card to the Portfolio Detail project (same ID as in Portfolio sidebar).' },
  { name: 'displayOrder', label: 'Display Order', type: 'number' },
  { name: 'isActive', label: 'Is Active', type: 'checkbox' },
];

export const serviceOverviewFields = [
  { name: 'title', label: 'Title', required: true },
  { name: 'slug', label: 'Detail Page Slug', required: true },
  { name: 'shortDescription', label: 'Card Description', type: 'textarea', required: true },
  { name: 'icon', label: 'Card Icon', type: 'icon' },
  { name: 'displayOrder', label: 'Display Order', type: 'number' },
  { name: 'isActive', label: 'Is Active', type: 'checkbox' },
];

export const serviceDetailFields = [
  { name: 'title', label: 'Page Title', required: true },
  { name: 'slug', label: 'Page Slug', required: true },
  { name: 'longDescription', label: 'Detail Page Description', type: 'textarea', required: true },
  { name: 'imageUrl', label: 'Service Image', type: 'image' },
  { name: 'highlights', label: 'Highlights', type: 'highlights' },
  { name: 'packagesSubtitle', label: 'Packages Subtitle', type: 'textarea' },
  { name: 'packages', label: 'Packages', type: 'packages' },
  { name: 'isActive', label: 'Is Active', type: 'checkbox' },
];

export const projectDetailFields = [
  { name: 'title', label: 'Page Title', required: true },
  { name: 'slug', label: 'Detail Page Slug', required: true, hint: 'Must match the Portfolio Overview card slug (example: vera-hair-care).' },
  { name: 'category', label: 'Category Badge', required: true },
  { name: 'description', label: 'Short Summary', type: 'textarea' },
  { name: 'longDescription', label: 'Full Project Description', type: 'textarea', required: true },
  { name: 'clientName', label: 'Client Name' },
  { name: 'industry', label: 'Industry' },
  { name: 'year', label: 'Year', type: 'number' },
  { name: 'projectDirection', label: 'Project Direction' },
  { name: 'websiteUrl', label: 'Website URL' },
  { name: 'mainImageUrl', label: 'Cover Image', type: 'image' },
  { name: 'galleryImages', label: 'Branding / Gallery Cards', type: 'gallery' },
  { name: 'detailFields', label: 'Extra Project Fields', type: 'project-fields' },
  { name: 'isFeatured', label: 'Is Featured', type: 'checkbox' },
  { name: 'isActive', label: 'Is Active', type: 'checkbox' },
];

export const adminResources = [
  {
    key: 'hero-sections',
    label: 'Hero Section',
    endpoint: '/api/hero-sections',
    singleRecord: true,
    publicPath: '/#home',
    sectionHint: 'Edits here update the Hero section on the public homepage immediately after save.',
    defaultValues: {
      badgeText: 'LEADING TECH SOLUTIONS IN SOMALIA',
      title: "Let's Make Your",
      highlightText: 'Business Flourish',
      description:
        'Streamline operations with our tailored ERP systems, innovative software development, and comprehensive cloud services. We believe that the prospect presented by technology has never been more spacious.',
      primaryButtonText: 'Get Started',
      primaryButtonUrl: '#contact',
      secondaryButtonText: 'Our Services',
      secondaryButtonUrl: '#services',
      imageUrl: '/img/hr8.png',
      isActive: true,
    },
    fields: [
      { name: 'badgeText', label: 'Badge Text' },
      { name: 'title', label: 'Title', required: true },
      { name: 'highlightText', label: 'Highlight Text' },
      { name: 'description', label: 'Description', type: 'textarea', required: true },
      { name: 'primaryButtonText', label: 'Primary Button Text', required: true },
      { name: 'primaryButtonUrl', label: 'Primary Button URL' },
      { name: 'secondaryButtonText', label: 'Secondary Button Text' },
      { name: 'secondaryButtonUrl', label: 'Secondary Button URL' },
      { name: 'imageUrl', label: 'Hero Image', type: 'image' },
      { name: 'isActive', label: 'Is Active', type: 'checkbox' },
    ],
  },
  {
    key: 'domain-extensions',
    label: 'Domain Extensions',
    endpoint: '/api/domain-extensions',
    fields: [
      { name: 'extension', label: 'Extension', required: true },
      { name: 'price', label: 'Price', required: true },
      { name: 'displayOrder', label: 'Display Order', type: 'number' },
      { name: 'isActive', label: 'Is Active', type: 'checkbox' },
    ],
  },
  {
    key: 'footer-content',
    label: 'Footer',
    endpoint: '/api/footer-content',
    singleRecord: true,
    publicPath: '/',
    sectionHint:
      'Update footer logo, description, social links, quick links, and legal links. Social icons can use icon picker or media library images.',
    defaultValues: {
      description:
        'We build premium, modern, and responsive digital solutions tailored to elevate your business in the digital landscape.',
      copyrightText: 'RAADSO TECH. All rights reserved.',
      logoUrl: '/img/logo-black.png',
      socialLinks: [
        { label: 'Twitter', url: '#', iconType: 'icon', icon: 'FaTwitter' },
        { label: 'LinkedIn', url: '#', iconType: 'icon', icon: 'FaLinkedin' },
        { label: 'GitHub', url: '#', iconType: 'icon', icon: 'FaGithub' },
        { label: 'Instagram', url: '#', iconType: 'icon', icon: 'FaInstagram' },
      ],
      quickLinks: [
        { label: 'Home', url: '#home' },
        { label: 'Services', url: '#services' },
        { label: 'Portfolio', url: '#portfolio' },
        { label: 'Contact', url: '#contact' },
      ],
      privacyUrl: '#',
      termsUrl: '#',
    },
    fields: [
      { name: 'logoUrl', label: 'Footer Logo', type: 'media-image' },
      { name: 'description', label: 'Description', type: 'textarea', required: true },
      { name: 'copyrightText', label: 'Copyright Text', required: true },
      { name: 'socialLinks', label: 'Social Links', type: 'footer-social' },
      { name: 'quickLinks', label: 'Quick Links', type: 'footer-quick' },
      { name: 'privacyUrl', label: 'Privacy Policy URL' },
      { name: 'termsUrl', label: 'Terms of Service URL' },
    ],
  },
  {
    key: 'about-company',
    label: 'About Company',
    endpoint: '/api/about-company',
    singleRecord: true,
    fields: [
      { name: 'tagline', label: 'Tagline' },
      { name: 'title', label: 'Title', required: true },
      { name: 'description', label: 'Description', type: 'textarea', required: true },
      { name: 'mission', label: 'Mission' },
      { name: 'vision', label: 'Vision' },
      { name: 'imageUrl', label: 'About Image', type: 'image' },
    ],
  },
  {
    key: 'portfolio-overviews',
    label: 'Portfolio Overview',
    endpoint: '/api/portfolio-overviews',
    fields: portfolioOverviewFields,
    defaultValues: { isActive: true, displayOrder: 0 },
  },
  {
    key: 'service-overviews',
    label: 'Services Overview',
    endpoint: '/api/service-overviews',
    fields: serviceOverviewFields,
  },
  {
    key: 'services',
    label: 'Service Details',
    endpoint: '/api/services',
    fields: serviceDetailFields,
  },
  {
    key: 'service-details',
    label: 'Service Details',
    endpoint: '/api/service-details',
    fields: [
      { name: 'serviceId', label: 'Service ID', type: 'number', required: true },
      { name: 'heading', label: 'Heading', required: true },
      { name: 'content', label: 'Content', type: 'textarea', required: true },
      { name: 'displayOrder', label: 'Display Order', type: 'number' },
    ],
  },
  {
    key: 'projects',
    label: 'Projects',
    endpoint: '/api/projects',
    fields: projectDetailFields,
  },
  {
    key: 'partners',
    label: 'Partners',
    endpoint: '/api/partners',
    fields: [
      { name: 'name', label: 'Name', required: true },
      { name: 'websiteUrl', label: 'Website URL' },
      { name: 'logoUrl', label: 'Partner Logo', type: 'image', required: true },
      { name: 'displayOrder', label: 'Display Order', type: 'number' },
      { name: 'isActive', label: 'Is Active', type: 'checkbox' },
    ],
  },
  {
    key: 'testimonials',
    label: 'Testimonials',
    endpoint: '/api/testimonials',
    fields: [
      { name: 'name', label: 'Name', required: true },
      { name: 'position', label: 'Position', required: true },
      { name: 'quote', label: 'Quote', type: 'textarea', required: true },
      { name: 'avatarUrl', label: 'Avatar', type: 'image' },
      { name: 'rating', label: 'Rating', type: 'number' },
      { name: 'isActive', label: 'Is Active', type: 'checkbox' },
    ],
  },
  {
    key: 'faqs',
    label: 'Why Choose Us',
    endpoint: '/api/faqs',
    fields: [
      { name: 'question', label: 'Title', required: true },
      { name: 'answer', label: 'Description', type: 'textarea', required: true },
      { name: 'icon', label: 'Card Icon', type: 'icon' },
      { name: 'displayOrder', label: 'Display Order', type: 'number' },
      { name: 'isActive', label: 'Is Active', type: 'checkbox' },
    ],
  },
  {
    key: 'blogs',
    label: 'Blogs',
    endpoint: '/api/blogs',
    fields: [
      { name: 'categoryId', label: 'Category ID', type: 'number', required: true },
      { name: 'title', label: 'Title', required: true },
      { name: 'slug', label: 'Slug', required: true },
      { name: 'summary', label: 'Summary', type: 'textarea', required: true },
      { name: 'content', label: 'Content', type: 'textarea', required: true },
      { name: 'coverImageUrl', label: 'Cover Image', type: 'image' },
      { name: 'isPublished', label: 'Is Published', type: 'checkbox' },
    ],
  },
  {
    key: 'admin-users',
    label: 'Users',
    endpoint: '/api/admin-users',
    access: { create: true, update: true, delete: true },
    sectionHint: 'Create and manage admin users. Each person needs their own email and password.',
    defaultValues: {
      isActive: true,
      password: '',
    },
    fields: [
      { name: 'fullName', label: 'Full Name', required: true },
      { name: 'email', label: 'Email', required: true },
      {
        name: 'password',
        label: 'Password',
        type: 'password',
        required: true,
        hideFromTable: true,
        hint: 'Required when creating. Leave blank when editing to keep the current password.',
      },
      { name: 'role', label: 'Role', readOnly: true, hideFromFormOnCreate: true },
      { name: 'isActive', label: 'Is Active', type: 'checkbox' },
      { name: 'avatarUrl', label: 'Avatar', type: 'image', hideFromTable: true },
    ],
  },
  {
    key: 'messages',
    label: 'Messages',
    endpoint: '/api/messages',
    inbox: true,
    access: { create: false, update: true, delete: true },
    publicPath: '/#contact',
    sectionHint:
      'Messages arrive here when visitors submit the contact form on the public website. You can read, mark as read, or delete them. Sending messages from admin is not allowed.',
    fields: [
      { name: 'firstName', label: 'First Name', readOnly: true },
      { name: 'lastName', label: 'Last Name', readOnly: true },
      { name: 'email', label: 'Email', readOnly: true },
      { name: 'phone', label: 'Phone', readOnly: true },
      { name: 'subject', label: 'Subject', readOnly: true },
      { name: 'content', label: 'Message', type: 'textarea', readOnly: true },
      { name: 'isRead', label: 'Mark as Read', type: 'checkbox' },
    ],
  },
  {
    key: 'social-media-links',
    label: 'Social Media Links',
    endpoint: '/api/social-media-links',
    singleRecord: true,
    access: { create: false, update: true, delete: false },
    fields: [
      { name: 'facebookUrl', label: 'Facebook URL' },
      { name: 'twitterUrl', label: 'Twitter / X URL' },
      { name: 'linkedInUrl', label: 'LinkedIn URL' },
      { name: 'instagramUrl', label: 'Instagram URL' },
      { name: 'githubUrl', label: 'GitHub URL' },
      { name: 'youtubeUrl', label: 'YouTube URL' },
      { name: 'tikTokUrl', label: 'TikTok URL' },
    ],
  },
  {
    key: 'company-colors',
    label: 'Company Colors',
    endpoint: '/api/company-colors',
    singleRecord: true,
    access: { create: false, update: true, delete: false },
    sectionHint: 'Manage company brand colors used across the website.',
    defaultValues: {
      primaryColor: '#f3c715',
      secondaryColor: '#000000',
      blackColor: '#000000',
      whiteColor: '#ffffff',
    },
    fields: [
      { name: 'primaryColor', label: 'Primary Color', type: 'color', required: true },
      { name: 'secondaryColor', label: 'Secondary Color', type: 'color', required: true },
      { name: 'blackColor', label: 'Black Color', type: 'color', required: true },
      { name: 'whiteColor', label: 'White Color', type: 'color', required: true },
    ],
  },
  {
    key: 'media-library',
    label: 'Media Library',
    endpoint: '/api/media-library',
    fields: [
      { name: 'fileName', label: 'File Name', required: true },
      { name: 'fileUrl', label: 'Media File', type: 'image', required: true },
      { name: 'contentType', label: 'Content Type' },
      { name: 'size', label: 'Size', type: 'number' },
      { name: 'projectId', label: 'Project ID', type: 'number' },
    ],
  },
  {
    key: 'contact-information',
    label: 'Contact Information',
    endpoint: '/api/contact-information',
    singleRecord: true,
    fields: [
      { name: 'email', label: 'Email', required: true },
      { name: 'phone', label: 'Phone', required: true },
      { name: 'address', label: 'Address', required: true },
      { name: 'facebookUrl', label: 'Facebook URL' },
      { name: 'linkedInUrl', label: 'LinkedIn URL' },
      { name: 'instagramUrl', label: 'Instagram URL' },
      { name: 'xUrl', label: 'X URL' },
    ],
  },
  {
    key: 'categories',
    label: 'Categories',
    endpoint: '/api/categories',
    fields: [
      { name: 'name', label: 'Name', required: true },
      { name: 'slug', label: 'Slug', required: true },
      { name: 'isActive', label: 'Is Active', type: 'checkbox' },
    ],
  },
];

export function getResourceByKey(resourceKey) {
  return adminResources.find((item) => item.key === resourceKey);
}
